module.exports = __webpack_public_path__ + "static/media/shampoo.1f5175e2.png";